import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import useSharedStyles from './theme/pbdqShared.styles';
import { sdsColors, sdsRadius } from './theme/solutionsDesignSystem';

import PbdqNav from './components/PbdqNav.comp';
import PbdqFooter from './components/PbdqFooter.comp';
import PbdqImageLightboxWrapper from './components/PbdqImageLightboxWrapper.comp';
import { useAgentChat } from './components/PbdqAgentChatContext';

import DqEveryChildClassroomsHero from '../../assets/images/PoweredByDQ/DqEveryChildClassroomsHero.jpg';
import DqEveryChildAnimatedSeries from '../../assets/images/PoweredByDQ/DqEveryChildAnimatedSeries.jpg';

import DqEveryChildExhibitionHero from '../../assets/images/PoweredByDQ/DqEveryChildExhibitionHero.jpg';
import DqEveryChildExhibitionPhoto1 from '../../assets/images/PoweredByDQ/DqEveryChildExhibitionPhoto1.jpg';
import DqEveryChildExhibitionPhoto2 from '../../assets/images/PoweredByDQ/DqEveryChildExhibitionPhoto2.jpg';
import DqEveryChildChallengeHero from '../../assets/images/PoweredByDQ/DqEveryChildChallengeHero.jpg';
import DqEveryChildChallengePhoto1 from '../../assets/images/PoweredByDQ/DqEveryChildChallengePhoto1.jpg';
import DqEveryChildChallengePhoto2 from '../../assets/images/PoweredByDQ/DqEveryChildChallengePhoto2.jpg';
import DqEveryChildWorkshopTeacherTraining from '../../assets/images/PoweredByDQ/DqEveryChildWorkshopTeacherTraining.jpg';
import DqEveryChildWorkshopParentGuide from '../../assets/images/PoweredByDQ/DqEveryChildWorkshopParentGuide.jpg';
import DqEveryChildWorkshopParentLecture from '../../assets/images/PoweredByDQ/DqEveryChildWorkshopParentLecture.jpg';
import DqEveryChildWorkshopCampaignPresentation from '../../assets/images/PoweredByDQ/DqEveryChildWorkshopCampaignPresentation.jpg';
import DqEveryChildOfflineToys from '../../assets/images/PoweredByDQ/DqEveryChildOfflineToys.jpg';
import DqEveryChildOfflineTradingCards from '../../assets/images/PoweredByDQ/DqEveryChildOfflineTradingCards.jpg';
import DqEveryChildOfflineComicBooks from '../../assets/images/PoweredByDQ/DqEveryChildOfflineComicBooks.jpg';
import DqEveryChildOfflineCampaign from '../../assets/images/PoweredByDQ/DqEveryChildOfflineCampaign.jpg';
import DqEveryChildOfflineWorksheets from '../../assets/images/PoweredByDQ/DqEveryChildOfflineWorksheets.jpg';
import DqEveryChildOfflinePrintedMaterials from '../../assets/images/PoweredByDQ/DqEveryChildOfflinePrintedMaterials.jpg';
import DqEveryChildOnlineCampaignWebsite from '../../assets/images/PoweredByDQ/DqEveryChildOnlineCampaignWebsite.jpg';
import DqEveryChildOnlinePlayLearn from '../../assets/images/PoweredByDQ/DqEveryChildOnlinePlayLearn.jpg';
import DqEveryChildOnlineEbooks from '../../assets/images/PoweredByDQ/DqEveryChildOnlineEbooks.png';

import DqEveryChildNationTurkeyHero from '../../assets/images/PoweredByDQ/DqEveryChildNationTurkeyHero.jpg';
import DqEveryChildNationTurkeyThumb from '../../assets/images/PoweredByDQ/DqEveryChildNationTurkeyThumb.jpg';
import DqEveryChildNationSingaporeHero from '../../assets/images/PoweredByDQ/DqEveryChildNationSingaporeHero.jpg';
import DqEveryChildNationSingaporeThumb from '../../assets/images/PoweredByDQ/DqEveryChildNationSingaporeThumb.jpg';
import DqEveryChildNationThailandHero from '../../assets/images/PoweredByDQ/DqEveryChildNationThailandHero.jpg';
import DqEveryChildNationThailandThumb from '../../assets/images/PoweredByDQ/DqEveryChildNationThailandThumb.jpg';
import DqEveryChildNationKoreaHero from '../../assets/images/PoweredByDQ/DqEveryChildNationKoreaHero.jpg';
import DqEveryChildNationKoreaThumb from '../../assets/images/PoweredByDQ/DqEveryChildNationKoreaThumb.jpg';

import DqEveryChildRolloutAssess from '../../assets/images/PoweredByDQ/DqEveryChildRolloutAssess.png';
import DqEveryChildRolloutLaunch from '../../assets/images/PoweredByDQ/DqEveryChildRolloutLaunch.png';
import DqEveryChildRolloutEmpower from '../../assets/images/PoweredByDQ/DqEveryChildRolloutEmpower.jpg';
import DqEveryChildRolloutActivate from '../../assets/images/PoweredByDQ/DqEveryChildRolloutActivate.png';

import LogoIrinaBokova from '../../assets/images/PoweredByDQ/LogoIrinaBokova.webp';
import LogoSimAnn from '../../assets/images/PoweredByDQ/LogoSimAnn.jpg';
import LogoStraitTimes from '../../assets/images/PoweredByDQ/LogoStraitTimes.png';

import LogoNatureHumanBehaviour from '../../assets/images/PoweredByDQ/LogoNatureHumanBehaviour.svg';
import LogoNature from '../../assets/images/PoweredByDQ/LogoNature.svg';
import LogoPubMed from '../../assets/images/PoweredByDQ/LogoPubMed.svg';
import LogoWorldEconomicForum from '../../assets/images/PoweredByDQ/LogoWorldEconomicForum.svg';
import LogoDQInstitute from '../../assets/images/PoweredByDQ/LogoDQInstitute.png';
import LogoForbes from '../../assets/images/PoweredByDQ/LogoForbes.svg';

import LogoSingtel from '../../assets/images/PoweredByDQ/LogoSingtel.svg';
import LogoNTU from '../../assets/images/PoweredByDQ/LogoNTU.png';
import LogoNIE from '../../assets/images/PoweredByDQ/LogoNIE.png';

const MOBILE = '@media (max-width: 820px)';
const NARROW = '@media (max-width: 1180px)';

const STATS = [
    { value: '1.5M+', label: 'children empowered' },
    { value: '80+', label: 'countries reached' },
    { value: '100+', label: 'partner organizations' },
    { value: '21+', label: 'languages' },
    { value: '+10%', label: 'average increase in DQ scores' },
    { value: '−15%', label: 'decrease in cyber-risks' },
];

const DQ_WORLD_CORE_FEATURES = [
    '8–10 hours of self-directed learning, delivered in the classroom or at home with minimal teacher supervision',
    'Eight core digital citizenship competencies, aligned with the IEEE 3527.1™ Standard for Digital Intelligence',
    'Real-time learner scorecards and progress reporting for parents, schools and program administrators',
    'National-language localization and co-branding for governments, partners and sponsoring organizations',
];

const EXT_BARS = ['#68C3EE', '#BCD253', '#EDB459', '#ED6628', '#B9316D'];
const EXT_TINTS = ['#E1F0F9', '#EDF2D5', '#FAEDDA', '#FBEDE4', '#F6E5F0'];
const EXT_INKS = ['#1F5F86', '#4E6A12', '#8A5A10', '#A63C0C', '#8E1F55'];

const EXTENSIONS = [
    {
        chip: 'Extension 1',
        h: 'National Exhibition',
        sell: 'Turn digital citizenship into a public moment the whole country talks about.',
        points: [
            'An immersive augmented-reality experience with interactive displays and stations — a shared public event for children, parents, and media.',
            '1st generation — iZ HERO exhibition (2010), National Science Museum of Korea, with the Korea Internet & Security Agency (KISA).',
            '2nd generation — iZ HERO exhibition (2013), Science Centre Singapore, with NTU, NIE, MOE and MDA.',
        ],
        items: [
            'Interactive AR stations',
            'School visit program',
            'Parent learning zone',
            'Media launch moment',
            '1st gen · National Science Museum of Korea · 2010',
            '2nd gen · Science Centre Singapore · 2013',
        ],
        videos: [
            {
                title: '1st generation · 2010',
                sub: 'iZ HERO exhibition — National Science Museum of Korea, with the Korea Internet & Security Agency (KISA)',
                type: 'file',
                src: 'https://www.dropbox.com/scl/fi/ns77uo33ac11ru56xzui1/iZhero_exhibition_science-musuem-Korea_h264.mp4?rlkey=0fxyyzu15h78jy1hl3mo0ebln&raw=1',
            },
            {
                title: '2nd generation · 2013',
                sub: 'iZ HERO exhibition — Science Centre Singapore, with NTU, NIE, MOE and MDA',
                type: 'file',
                src: 'https://www.dropbox.com/scl/fi/ssiz3lbclgq0ts4ehef1v/iZ-HERO-Digital-Interactive-Exhibition.mp4?rlkey=wvk2ltzbtevqwr9w4ivaczvi1&raw=1',
            },
        ],
        photos: [
            { img: DqEveryChildExhibitionHero, alt: 'The #DQEveryChild National Exhibition entrance' },
            { img: DqEveryChildExhibitionPhoto1, alt: 'A child interacting with an animated character display at the National Exhibition' },
            { img: DqEveryChildExhibitionPhoto2, alt: 'Children playing an interactive touch-wall game at the National Exhibition' },
        ],
    },
    {
        chip: 'Extension 2',
        h: 'National DQ Challenge',
        sell: 'A nationwide competition that keeps momentum going long after launch.',
        points: [
            'A nationwide competition recognizing top children, teachers, and schools.',
            'Turn-key rollout blueprint, trophies, prizes, and certificate templates.',
            'Feeds the national dashboard as it runs.',
        ],
        items: ['Turn-key blueprint', 'Trophies & prizes', 'Certificate templates', 'National recognition event'],
        videos: [
            {
                title: 'National DQ Challenge',
                sub: 'A nationwide competition recognising top children, teachers and schools',
                type: 'vimeo',
                id: '916882815',
            },
        ],
        photos: [
            { img: DqEveryChildChallengeHero, alt: 'Students celebrating as the Grand Finale Challenge Winner at the National DQ Challenge' },
            { img: DqEveryChildChallengePhoto1, alt: 'Students on stage at a National DQ Challenge event' },
            { img: DqEveryChildChallengePhoto2, alt: 'Students holding a Grand Finale Challenge Winner cheque' },
        ],
    },
    {
        chip: 'Extension 3',
        h: 'Digital Parenting & Teacher Workshops',
        sell: 'The adults around each child become the program’s strongest multiplier.',
        points: [
            'Assessments and scorecards for children and parents, plus a parent handbook.',
            '3-hour teacher training workshop and 1-hour parent workshop.',
            '1-hour student assembly program, with physical collateral.',
        ],
        items: ['Parent handbook', 'Parent & child scorecards', '3-hr teacher training', '1-hr parent workshop', 'Student assembly'],
        videos: [
            {
                title: 'Teacher’s Workshop at Google',
                sub: 'Teacher training, parent workshop and student assembly',
                type: 'youtube',
                id: 'VtjnOBSR1yY',
            },
            {
                title: 'Parent’s Workshop, Science Centre Singapore',
                sub: 'Engaging parents alongside students for cyber wellness',
                type: 'youtube',
                id: 'hLe_Slm5AoA',
            },
        ],
        photos: [
            { img: DqEveryChildWorkshopCampaignPresentation, alt: 'A digital parenting workshop presenting iZHERO.net to parents' },
            { img: DqEveryChildWorkshopTeacherTraining, alt: 'A DQ World teacher training session' },
            { img: DqEveryChildWorkshopParentGuide, alt: 'A coach presenting the DQ World program guide for parents' },
            { img: DqEveryChildWorkshopParentLecture, alt: 'Parents attending a digital parenting workshop lecture' },
        ],
    },
    {
        chip: 'Extension 4',
        h: 'Offline Resources',
        sell: 'Reach every child — including those without reliable devices or connectivity.',
        points: [
            'Physical and downloadable materials carrying the same eight digital citizenship skills.',
            'Built for homes and classrooms with low or no connectivity.',
            'Toys, trading cards, comic books, e-books, worksheets, and printed materials.',
        ],
        items: ['Toys', 'Trading cards', 'Comic book', 'Downloadable worksheets', 'Printed materials'],
        videos: [
            {
                title: 'Offline Resources',
                sub: 'Toys, trading cards, comic books and printed materials',
                placeholderImg: DqEveryChildOfflineCampaign,
            },
        ],
        photos: [
            { img: DqEveryChildOfflineCampaign, alt: 'The #DQEveryChild offline campaign materials' },
            { img: DqEveryChildOfflineToys, alt: 'Toys' },
            { img: DqEveryChildOfflineTradingCards, alt: 'Trading cards' },
            { img: DqEveryChildOfflineComicBooks, alt: 'Comic books' },
            { img: DqEveryChildOfflineWorksheets, alt: 'Worksheets' },
            { img: DqEveryChildOfflinePrintedMaterials, alt: 'Printed materials' },
        ],
    },
    {
        chip: 'Extension 5',
        h: 'Online Resources',
        sell: 'Extend the learning beyond DQ World — wherever children already are online.',
        points: [
            'The 42-episode animated series — 120 minutes, dubbed in 8 languages — following a young child becoming a smart, discerning online hero.',
            'A public campaign website for your national rollout (e.g. izherochallenge.net) — ready to localize and co-brand.',
            'A play-and-learn site for young children (e.g. izhero.net), with e-books and downloadable digital materials for schools and families.',
        ],
        items: ['Animated series · 42 episodes', 'Public campaign website', 'Play & learn site', 'E-books', '8 languages'],
        videos: [
            {
                title: 'The animated series',
                sub: '42 episodes · 120 minutes · dubbed in 8 languages',
                placeholderImg: DqEveryChildAnimatedSeries,
            },
        ],
        photos: [
            { img: DqEveryChildAnimatedSeries, alt: 'The #DQEveryChild animated series' },
            { img: DqEveryChildOnlineCampaignWebsite, alt: 'Public campaign website' },
            { img: DqEveryChildOnlinePlayLearn, alt: 'Play & learn site' },
            { img: DqEveryChildOnlineEbooks, alt: 'E-books and downloadable digital materials' },
        ],
    },
];

const PUBS = [
    {
        outlet: 'Nature Human Behaviour · 2021',
        title: 'On the need for a common global framework for digital literacy, skills, and readiness',
        url: 'https://www.nature.com/articles/s41562-021-01074-z',
        logo: LogoNatureHumanBehaviour,
        logoStyle: { maxHeight: 24, maxWidth: 190 },
    },
    {
        outlet: 'Nature · 2018',
        title: 'Commentary on raising digital intelligence in the AI age',
        url: 'https://www.nature.com/articles/d41586-018-06848-6',
        logo: LogoNature,
        logoStyle: { maxHeight: 22, maxWidth: 130 },
    },
    {
        outlet: 'PubMed · peer-reviewed · 2018',
        title: 'Peer-reviewed study of the program’s effect on children’s digital citizenship and cyber-risk',
        url: 'https://pubmed.ncbi.nlm.nih.gov/29595788/',
        logo: LogoPubMed,
        logoStyle: { maxHeight: 30, maxWidth: 130 },
    },
    {
        outlet: 'PubMed · peer-reviewed · 2024',
        title: 'Peer-reviewed research on measuring children’s digital skills and online safety',
        url: 'https://pubmed.ncbi.nlm.nih.gov/39253112/',
        logo: LogoPubMed,
        logoStyle: { maxHeight: 30, maxWidth: 130 },
    },
    {
        outlet: 'Forbes · World Economic Forum · 2018',
        title: 'Forget IQ — digital intelligence will be what matters in the future',
        url: 'https://www.forbes.com/sites/worldeconomicforum/2018/02/09/forget-iq-digital-intelligence-will-be-what-matters-in-the-future/',
        logo: LogoForbes,
        logoStyle: { maxHeight: 26, maxWidth: 120 },
    },
    {
        outlet: 'World Economic Forum · 2020',
        title: 'Children’s digital risks, cybersecurity, and screen time during COVID-19',
        url: 'https://www.weforum.org/stories/health-and-healthcare-systems/children-digital-risks-cybersecurity-screentime-covid19/',
        logo: LogoWorldEconomicForum,
        logoStyle: { maxHeight: 42, maxWidth: 85 },
    },
    {
        outlet: 'World Economic Forum · press · 2017',
        title: 'Singapore and Australia first to launch DQ Institute cyber-risk reporting system for children',
        url: 'https://www.weforum.org/press/2017/09/singapore-and-australia-first-to-launch-dq-institute-cyber-risk-reporting-system-for-children/',
        logo: LogoWorldEconomicForum,
        logoStyle: { maxHeight: 42, maxWidth: 85 },
    },
    {
        outlet: 'DQ Institute · 2018',
        title: 'The 2018 DQ Impact Report',
        url: 'https://www.dqinstitute.org/2018dq_impact_report/',
        logo: LogoDQInstitute,
        logoStyle: { maxHeight: 32, maxWidth: 140 },
    },
];

const QUOTES = [
    {
        text: '#DQEveryChild (iZ HERO) does outstanding work in promoting digital citizenship for children and parents!',
        attribution: 'Irina Bokova, Director-General, UNESCO',
        photo: LogoIrinaBokova,
    },
    {
        text: 'Within the #DQEveryChild (iZ HERO) exhibition, educational information on cyber wellness for parents is available and provides opportunities for parents to learn alongside their children.',
        attribution: 'Sim Ann, Senior Parliamentary Secretary for Education and Communications & Information, Singapore',
        photo: LogoSimAnn,
        photoStyle: { objectPosition: 'center 20%' },
    },
    {
        text: 'The cyber wellness program, #DQEveryChild (iZ HERO) Challenge, allows primary school children to learn about cyber bullying through a game, comic strips and other online activities — and the appropriate ways to respond when they are targeted.',
        attribution: 'The Straits Times, Singapore, 2014',
        photo: LogoStraitTimes,
    },
];

const NATIONS = [
    {
        country: 'Türkiye',
        dot: '#ED6628',
        h: 'Turkcell × DQ',
        b: '50,000+ online sign-ups at launch in 2017. DQ World localized into Turkish with the Ministry of Education, and a CEO-led national launch event.',
        chips: ['50,000+ sign-ups at launch', '2017 national launch year'],
        video: { type: 'youtube', id: 'XrrAri3niWQ' },
        photos: [
            { img: DqEveryChildNationTurkeyHero, alt: 'Turkcell and DQ Institute presenting DQ World on stage in Türkiye' },
            { img: DqEveryChildNationTurkeyThumb, alt: 'Children using the interactive Turkcell "Dijital Zeka" DQ World exhibit' },
        ],
    },
    {
        country: 'Singapore',
        dot: '#EDB459',
        h: 'Singtel × DQ',
        b: '15,425 students reached in a national #DQEveryChild campaign, with measurable gains in children’s digital citizenship.',
        chips: ['15,425 students reached', '2016 national launch year'],
        video: { type: 'vimeo', id: '216728369' },
        photos: [
            { img: DqEveryChildNationSingaporeHero, alt: 'Students using tablets during a #DQEveryChild school activity in Singapore' },
            { img: DqEveryChildNationSingaporeThumb, alt: 'Students exploring #DQEveryChild posters in a Singapore school corridor' },
        ],
    },
    {
        country: 'Thailand',
        dot: '#BCD253',
        h: 'AIS × DQ',
        b: 'A nationwide rollout in Thai — DQ World, teacher training, and school activation delivered across the country. The campaign video passed 19 million views.',
        chips: ['19M+ campaign video views', 'Nationwide rollout across Thailand'],
        video: { type: 'file', src: 'https://www.dropbox.com/scl/fi/nj0ixqq5gnnnamn46zofy/.mp4?rlkey=ywom4lit63wt559impe771ivy&raw=1' },
        photos: [
            { img: DqEveryChildNationThailandHero, alt: 'AIS and DQ Institute launching the "อุ่นใจ Cyber" program on stage in Thailand' },
            { img: DqEveryChildNationThailandThumb, alt: 'An AIS × DQ panel discussion on the DQ Test and digital skills in Thailand' },
        ],
    },
    {
        country: 'Korea',
        dot: '#68C3EE',
        h: 'Kakao × DQ',
        b: 'A national #DQEveryChild campaign delivered with Kakao — bringing DQ World and digital citizenship education to Korean children in Korean. Campaign figures and story to be supplied.',
        chips: ['Korean national language delivery'],
        video: { type: 'file', src: 'https://www.dropbox.com/scl/fi/zxl4gfsknxj6r7dhbkjbd/iZ-HERO-_-2.mp4?rlkey=tfe0bpxxi51fbhqos2x9wrvzq&raw=1' },
        photos: [
            { img: DqEveryChildNationKoreaHero, alt: 'The iZ HERO Digital Leadership School university supporters launch event, with Daum Kakao' },
            { img: DqEveryChildNationKoreaThumb, alt: 'A Korean classroom using the iZ HERO board game' },
        ],
    },
];

const ROLLOUT_STEPS = [
    {
        chip: 'Phase 1 · optional',
        h: 'Assess',
        b: 'Measure your baseline national DQ score and top cyber-risks against global benchmarks, using the COS Children Assessment. Produces a national report you own, and pinpoints the priority groups so the rollout targets what matters most.',
        img: DqEveryChildRolloutAssess,
        alt: 'A DQ Score Profile report benchmarking a child against national and global averages',
        ring: '#68C3EE',
        ink: '#1F5F86',
    },
    {
        chip: 'Phase 2',
        h: 'Launch',
        b: 'Deploy DQ World — the 8–10 hour self-directed e-learning program covering all eight digital citizenship skills — localized into your national language and co-branded to your organization. It works in the classroom or at home, with minimal teacher supervision, and gives parents real-time scorecards and schools progress reports.',
        img: DqEveryChildRolloutLaunch,
        alt: 'The DQ World web application login and mission selection screen',
        ring: '#BCD253',
        ink: '#4E6A12',
    },
    {
        chip: 'Phase 3',
        h: 'Empower',
        b: 'Build local capacity through offline sessions: a 3-hour teacher training workshop, a 1-hour parent workshop, and a 1-hour student assembly — so schools, families, and communities own the initiative rather than receiving it.',
        img: DqEveryChildRolloutEmpower,
        alt: 'A room full of teachers participating in a DQ World training session',
        ring: '#EDB459',
        ink: '#8A5A10',
    },
    {
        chip: 'Phase 4',
        h: 'Activate and measure',
        b: 'A national launch event and the National DQ Challenge build public momentum and recognize top children, teachers, and schools. Then a national impact report benchmarks your progress globally and informs policy.',
        img: DqEveryChildRolloutActivate,
        alt: 'A high-level dashboard display showing nationwide DQ assessments and analytics',
        ring: '#ED6628',
        ink: '#A63C0C',
    },
];

const TIMELINE = [
    'Month 1 — mobilize & localize',
    'Month 2 — baseline assessment',
    'Months 2–3 — train & enable',
    'Months 3–5 — nationwide rollout & launch event',
];

const useStyles = makeStyles(() => ({
    pageWrapper: {
        fontFamily: "'Figtree', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        color: '#1B2430',
        background: '#FFFFFF',
        WebkitFontSmoothing: 'antialiased',
    },
    sectionOuter: {
        width: '100%',
    },
    sectionInner: {
        maxWidth: 1320,
        margin: '0 auto',
        padding: 'clamp(36px, 4.5vw, 56px) clamp(20px, 4vw, 56px)',
        [MOBILE]: {
            padding: '48px 20px',
        },
    },

    // ── SECTION 0: HERO ────────────────────────────────────────────────────────
    heroSection: {
        background: 'radial-gradient(70% 90% at 86% 10%, #DCE7F3 0%, rgba(220, 231, 243, 0) 60%), linear-gradient(180deg, #F6F8FB 0%, #FFFFFF 100%)',
    },
    heroInner: {
        maxWidth: 1320,
        margin: '0 auto',
        padding: 'clamp(36px, 4.5vw, 64px) clamp(20px, 4vw, 56px) clamp(24px, 3vw, 36px)',
        display: 'flex',
        flexDirection: 'column',
        gap: 'clamp(18px, 2.2vw, 26px)',
        boxSizing: 'border-box',
        [MOBILE]: {
            padding: '24px 16px 20px',
            gap: 16,
        },
    },
    heroTopRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px clamp(24px, 3.5vw, 48px)',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: '100%',
    },
    heroTextCol: {
        flex: '1 1 440px',
        minWidth: 0,
        display: 'grid',
        gap: 12,
        alignContent: 'start',
    },
    heroTitle: {
        fontSize: 'clamp(36px, 4.2vw, 60px)',
        lineHeight: 1.04,
        letterSpacing: '-0.03em',
        fontWeight: 800,
        margin: 0,
        color: '#1B2430',
    },
    accent: {
        color: '#ED6628',
    },
    heroLead: {
        fontSize: 'clamp(16px, 1.3vw, 18px)',
        lineHeight: 1.55,
        color: '#5B6470',
        margin: 0,
        maxWidth: '58ch',
    },
    heroBodyPara: {
        fontSize: 15,
        lineHeight: 1.55,
        color: '#5B6470',
        margin: 0,
        maxWidth: '58ch',
    },
    heroCalloutBadge: {
        fontSize: 14,
        lineHeight: 1.55,
        margin: 0,
        padding: '12px 16px',
        borderRadius: 12,
        background: '#FDECE3',
        color: '#A63C0C',
        fontWeight: 600,
        maxWidth: '58ch',
    },
    heroBtnRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 12,
        marginTop: 2,
    },
    btnRequestHero: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        height: 52,
        padding: '0 24px',
        borderRadius: 999,
        background: '#ED6628',
        color: '#FFFFFF',
        border: 'none',
        textDecoration: 'none',
        fontSize: 15,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        transition: 'background 200ms cubic-bezier(.32,.72,0,1)',
        '&:hover': {
            background: '#D5581D',
            color: '#FFFFFF',
        },
    },
    btnPlanRollout: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 52,
        padding: '0 24px',
        borderRadius: 999,
        background: '#FFFFFF',
        color: '#1B2430',
        border: '1px solid #D5D9E0',
        textDecoration: 'none',
        fontSize: 15,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        transition: 'border-color 200ms',
        '&:hover': {
            borderColor: '#1B2430',
            color: '#1B2430',
        },
    },
    heroArtCol: {
        flex: '1 1 420px',
        minWidth: 0,
        maxWidth: 560,
        position: 'relative',
        [MOBILE]: {
            flex: '1 1 100%',
            maxWidth: '100%',
        },
    },
    heroPhotoCard: {
        position: 'relative',
        borderRadius: 22,
        overflow: 'hidden',
        background: '#172939',
        aspectRatio: '16/9',
    },
    heroLightboxWrap: {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        display: 'block',
        borderRadius: 0,
        maxWidth: 'none',
        maxHeight: 'none',
    },
    heroImg: {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: '50% 50%',
        display: 'block',
        filter: 'saturate(0.92) contrast(1.02)',
    },
    heroGradientOverlay: {
        position: 'absolute',
        inset: 0,
        background: 'linear-gradient(160deg, rgba(23,41,57,0.55) 0%, rgba(23,41,57,0.18) 45%, rgba(23,41,57,0) 70%), linear-gradient(0deg, rgba(23,41,57,0.45) 0%, rgba(23,41,57,0) 40%)',
        pointerEvents: 'none',
    },
    heroRing1: {
        position: 'absolute',
        inset: 'auto -10% -30% 30%',
        height: '70%',
        borderRadius: '50%',
        border: '1px solid rgba(255,255,255,0.35)',
        pointerEvents: 'none',
    },
    heroRing2: {
        position: 'absolute',
        inset: '-20% -20% auto 45%',
        height: '70%',
        borderRadius: '50%',
        border: '1px solid rgba(255,255,255,0.25)',
        pointerEvents: 'none',
    },

    // ── SECTION 1: PROOF / STATS ───────────────────────────────────────────────
    proofSection: {
        background: '#FFFFFF',
    },
    proofGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
        background: '#FFFFFF',
        border: '1px solid #E6E9EE',
        borderRadius: 18,
        overflow: 'hidden',
        width: '100%',
        boxSizing: 'border-box',
        '@media (max-width: 960px)': {
            gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        },
        [MOBILE]: {
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        },
    },
    proofItem: {
        padding: 'clamp(12px, 1.3vw, 18px) clamp(10px, 1.1vw, 16px)',
        display: 'grid',
        gap: 6,
        borderRight: '1px solid #E6E9EE',
        borderBottom: '1px solid #E6E9EE',
        margin: '0 -1px -1px 0',
        boxSizing: 'border-box',
        '&:last-child': {
            borderRight: 'none',
        },
    },
    proofNum: {
        fontSize: 'clamp(22px, 2.2vw, 32px)',
        lineHeight: 1,
        fontWeight: 800,
        letterSpacing: '-0.035em',
        color: '#ED6628',
        margin: 0,
        fontVariantNumeric: 'tabular-nums',
        whiteSpace: 'nowrap',
    },
    proofLabel: {
        fontSize: 'clamp(10.5px, 0.85vw, 12px)',
        lineHeight: 1.35,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: '#5B6470',
        margin: 0,
    },

    // ── SECTION 2: MANDATORY CORE (DQ WORLD) ──────────────────────────────────
    coreSection: {
        background: '#F4F6F9',
    },
    coreBanner: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'clamp(24px, 3vw, 48px)',
        alignItems: 'center',
        padding: 'clamp(24px, 3vw, 44px)',
        borderRadius: 24,
        background: '#172939',
        color: '#FFFFFF',
    },
    coreLeftCol: {
        flex: '1 1 440px',
        minWidth: 0,
        display: 'grid',
        gap: 16,
    },
    coreTagBadge: {
        display: 'inline-flex',
        width: 'max-content',
        maxWidth: '100%',
        alignItems: 'center',
        padding: '8px 14px',
        borderRadius: 999,
        background: 'rgba(255, 255, 255, 0.12)',
        fontSize: 12,
        lineHeight: 1.3,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        fontWeight: 700,
        color: '#FFFFFF',
    },
    coreHeading: {
        fontSize: 'clamp(28px, 3.4vw, 48px)',
        lineHeight: 1.05,
        letterSpacing: '-0.03em',
        fontWeight: 800,
        margin: 0,
    },
    corePara: {
        fontSize: 15.5,
        lineHeight: 1.6,
        margin: 0,
        color: '#D9E3EE',
    },
    coreLogosBlock: {
        display: 'grid',
        gap: 10,
        marginTop: 6,
    },
    coreLogosLabel: {
        fontSize: 12,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        fontWeight: 700,
        color: '#8AA3BC',
    },
    coreLogosRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
    },
    coreLogoBox: {
        width: 150,
        height: 64,
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
    },
    coreLogoImg: {
        width: 'auto',
        height: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        display: 'block',
    },
    coreRightCol: {
        flex: '1 1 400px',
        minWidth: 0,
        maxWidth: 620,
        display: 'grid',
        gap: 14,
        [MOBILE]: {
            maxWidth: '100%',
        },
    },
    coreVideoFrame: {
        padding: '56.25% 0 0 0',
        position: 'relative',
        borderRadius: 16,
        overflow: 'hidden',
        background: '#0F1C27',
        border: '1px solid rgba(255, 255, 255, 0.12)',
    },
    coreIframe: {
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        border: 0,
    },
    coreFeaturesList: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'grid',
        gap: 8,
    },
    coreFeatureItem: {
        display: 'grid',
        gridTemplateColumns: '18px 1fr',
        gap: 10,
        fontSize: 14,
        lineHeight: 1.5,
        color: '#D9E3EE',
    },

    // ── SECTION 3: EXTENSIONS ──────────────────────────────────────────────────
    extendSection: {
        background: '#FFFFFF',
    },
    sectionOverline: {
        display: 'block',
        fontSize: 13,
        lineHeight: 1,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        fontWeight: 700,
        color: '#2A4057',
        marginBottom: 16,
    },
    extendHeaderRow: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 14,
        width: '100%',
    },
    extendTitle: {
        fontSize: 'clamp(28px, 3.4vw, 46px)',
        lineHeight: 1.1,
        letterSpacing: '-0.025em',
        fontWeight: 800,
        margin: 0,
        width: '100%',
        color: '#1B2430',
    },
    extendDesc: {
        fontSize: 16,
        lineHeight: 1.55,
        margin: 0,
        width: '100%',
        color: '#5B6470',
    },
    extTabsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
        gap: 12,
        marginTop: 36,
        '@media (max-width: 960px)': {
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        },
        '@media (max-width: 560px)': {
            gridTemplateColumns: '1fr',
        },
    },
    extTabBtn: {
        display: 'grid',
        gap: 10,
        alignContent: 'start',
        textAlign: 'left',
        padding: '18px 18px 20px',
        borderRadius: 18,
        color: '#1B2430',
        cursor: 'pointer',
        fontFamily: 'inherit',
        transition: 'background 240ms cubic-bezier(.32,.72,0,1), border-color 240ms cubic-bezier(.32,.72,0,1), transform 240ms cubic-bezier(.32,.72,0,1)',
        border: '1px solid #E6E9EE',
        background: '#FFFFFF',
        '&:hover': {
            transform: 'translateY(-2px)',
        },
    },
    extTabBtnSelected: {
        transform: 'translateY(-2px)',
    },
    extTabChip: {
        fontSize: 11,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        fontWeight: 700,
    },
    extTabH: {
        fontSize: 16,
        fontWeight: 800,
        lineHeight: 1.25,
        letterSpacing: '-0.01em',
    },
    extPanel: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: 16,
        border: '1px solid #E6E9EE',
        borderRadius: 24,
        overflow: 'hidden',
        background: '#FFFFFF',
    },
    extPanelLeft: {
        flex: '1.2 1 400px',
        minWidth: 0,
        padding: 'clamp(24px, 3vw, 44px)',
        display: 'grid',
        gap: 16,
        alignContent: 'start',
    },
    extBadge: {
        display: 'inline-flex',
        width: 'max-content',
        alignItems: 'center',
        padding: '7px 12px',
        borderRadius: 999,
        fontSize: 11.5,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
    },
    extHeading: {
        fontSize: 'clamp(24px, 2.6vw, 34px)',
        lineHeight: 1.1,
        letterSpacing: '-0.02em',
        fontWeight: 800,
        margin: 0,
        color: '#1B2430',
    },
    extSellText: {
        fontSize: 17,
        lineHeight: 1.45,
        fontWeight: 700,
        margin: 0,
        color: '#A63C0C',
    },
    extPointsList: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'grid',
        gap: 10,
    },
    extPointItem: {
        display: 'grid',
        gridTemplateColumns: '18px 1fr',
        gap: 10,
        fontSize: 14.5,
        lineHeight: 1.55,
        color: '#5B6470',
    },
    extChipsWrap: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
    },
    extChipItem: {
        padding: '6px 11px',
        borderRadius: 999,
        background: '#FFFFFF',
        border: '1px solid #E6E9EE',
        fontSize: 12.5,
        fontWeight: 600,
        color: '#1B2430',
        whiteSpace: 'nowrap',
    },
    extPhotosWrap: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
        gap: 10,
        marginTop: 6,
    },
    extPhotoThumb: {
        width: '100%',
        aspectRatio: '3/2',
        objectFit: 'cover',
        borderRadius: 12,
        display: 'block',
        border: '1px solid #E6E9EE',
    },
    extPressReleaseLink: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        marginTop: 10,
        fontSize: 14.5,
        fontWeight: 700,
        color: '#ED6628',
        textDecoration: 'none',
        transition: 'color 160ms, opacity 160ms',
        '&:hover': {
            color: '#D5581D',
            textDecoration: 'underline',
        },
    },
    extPanelRight: {
        flex: '1 1 340px',
        minWidth: 0,
        padding: 'clamp(24px, 3vw, 36px)',
        background: '#E8F1FB',
        display: 'grid',
        gap: 14,
        alignContent: 'start',
    },
    extWatchLabel: {
        fontSize: 11.5,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        fontWeight: 700,
        color: '#6B7280',
    },
    extVideosList: {
        display: 'grid',
        gap: 16,
    },
    extVideoFigure: {
        margin: 0,
        display: 'grid',
        gap: 8,
    },
    extVideoWrap: {
        position: 'relative',
        aspectRatio: '16/9',
        borderRadius: 12,
        overflow: 'hidden',
        background: '#0F1C27',
    },
    extVideoLinkOverlay: {
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
    },
    playBtnCircle: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        height: 48,
        borderRadius: '50%',
        background: '#ED6628',
        color: '#FFFFFF',
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
    },
    extVideoFigcaption: {
        display: 'grid',
        gap: 2,
    },
    extVideoFigTitle: {
        fontSize: 14,
        fontWeight: 700,
        letterSpacing: '-0.01em',
        color: '#1B2430',
    },
    extVideoFigSub: {
        fontSize: 12.5,
        lineHeight: 1.45,
        color: '#5B6470',
    },

    // ── SECTION 4: RESEARCH ───────────────────────────────────────────────────
    researchSection: {
        background: '#FFF8F4',
    },
    researchTitle: {
        fontSize: 'clamp(28px, 3.2vw, 44px)',
        lineHeight: 1.08,
        letterSpacing: '-0.025em',
        fontWeight: 800,
        margin: 0,
        color: '#1B2430',
    },
    researchGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))',
        gap: 'clamp(12px, 1.4vw, 16px)',
        marginTop: 36,
    },
    researchCard: {
        display: 'grid',
        gap: 12,
        alignContent: 'start',
        padding: '20px 22px',
        border: '1px solid #E6E9EE',
        borderRadius: 18,
        background: '#FFFFFF',
        textDecoration: 'none',
        color: 'inherit',
        transition: 'border-color 200ms cubic-bezier(.32,.72,0,1), transform 300ms cubic-bezier(.32,.72,0,1)',
        '&:hover': {
            borderColor: '#1B2430',
            transform: 'translateY(-2px)',
        },
    },
    researchLogoBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
        maxWidth: 220,
        height: 52,
        borderRadius: 10,
        background: '#F8F9FB',
        border: '1px solid #EEF1F4',
        padding: '8px 14px',
        boxSizing: 'border-box',
    },
    researchLogoImg: {
        width: 'auto',
        height: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        objectPosition: 'left center',
        display: 'block',
    },
    researchOutlet: {
        fontSize: 12,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        fontWeight: 700,
        color: '#6B7280',
    },
    researchHeading: {
        fontSize: 15,
        lineHeight: 1.45,
        fontWeight: 600,
        color: '#1B2430',
    },

    // ── SECTION 5: QUOTES ──────────────────────────────────────────────────────
    quotesSection: {
        background: '#FFFFFF',
    },
    quoteContainerCard: {
        border: '1px solid #E6E9EE',
        borderRadius: 24,
        overflow: 'hidden',
        background: '#F4F6F9',
    },
    quoteInnerBox: {
        padding: 'clamp(28px, 3.4vw, 52px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        minHeight: 380,
        gap: 24,
        minWidth: 0,
        [MOBILE]: {
            minHeight: 'auto',
        },
    },
    quoteBodyRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1,
        gap: 36,
        [MOBILE]: {
            flexDirection: 'column-reverse',
            alignItems: 'flex-start',
            gap: 24,
        },
    },
    blockquote: {
        margin: 0,
        display: 'grid',
        gap: 18,
        flex: 1,
        minWidth: 0,
    },
    quoteText: {
        fontSize: 'clamp(20px, 2.2vw, 30px)',
        lineHeight: 1.35,
        fontWeight: 600,
        letterSpacing: '-0.015em',
        margin: 0,
        maxWidth: '40ch',
        color: '#1B2430',
    },
    quoteLeaderSide: {
        flex: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: 240,
        [MOBILE]: {
            maxWidth: '100%',
            alignItems: 'flex-start',
            textAlign: 'left',
        },
    },
    quoteLeaderCircle: {
        width: 140,
        height: 140,
        borderRadius: '50%',
        overflow: 'hidden',
        background: '#FFFFFF',
        border: '3px solid #E6E9EE',
        boxShadow: '0 8px 24px rgba(27, 36, 48, 0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 12,
        [MOBILE]: {
            width: 100,
            height: 100,
        },
    },
    quoteLeaderImg: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    quoteLeaderAttribution: {
        fontSize: 14,
        lineHeight: 1.45,
        fontWeight: 500,
        color: '#1B2430',
    },
    quoteControlsRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 14,
        flexWrap: 'wrap',
    },
    quoteDotsGroup: {
        display: 'flex',
        gap: 6,
        alignItems: 'center',
    },
    quoteDotBtn: {
        height: 8,
        borderRadius: 999,
        border: 0,
        padding: 0,
        cursor: 'pointer',
        transition: 'width 300ms cubic-bezier(.32,.72,0,1), background 300ms',
    },
    quoteArrowsGroup: {
        display: 'flex',
        gap: 8,
    },
    quoteArrowBtn: {
        width: 44,
        height: 44,
        borderRadius: 999,
        border: '1px solid #D5D9E0',
        background: '#FFFFFF',
        cursor: 'pointer',
        color: '#1B2430',
        fontSize: 16,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'border-color 200ms',
        '&:hover': {
            borderColor: '#1B2430',
        },
    },

    // ── SECTION 6: NATIONS ────────────────────────────────────────────────────
    nationsSection: {
        background: '#F4F6F9',
    },
    nationsTitle: {
        fontSize: 'clamp(28px, 3.2vw, 44px)',
        lineHeight: 1.1,
        letterSpacing: '-0.025em',
        fontWeight: 800,
        margin: 0,
        maxWidth: '36ch',
        color: '#1B2430',
    },
    nationsLead: {
        fontSize: 15.5,
        lineHeight: 1.6,
        margin: 0,
        maxWidth: '68ch',
        color: '#5B6470',
    },
    nationsList: {
        display: 'grid',
        gap: 'clamp(14px, 1.6vw, 20px)',
        marginTop: 36,
    },
    nationArticle: {
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 6fr) minmax(0, 5fr)',
        gap: 'clamp(20px, 2.6vw, 36px)',
        padding: 'clamp(18px, 2.2vw, 28px)',
        border: '1px solid #E6E9EE',
        borderRadius: 24,
        background: '#FFFFFF',
        '@media (max-width: 960px)': {
            gridTemplateColumns: '1fr',
        },
    },
    nationVideoCol: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        minWidth: 0,
        height: '100%',
    },
    nationVideoWrap: {
        position: 'relative',
        flex: 1,
        width: '100%',
        minHeight: 220,
        borderRadius: 14,
        overflow: 'hidden',
        background: '#0F1C27',
    },
    nationRightCol: {
        display: 'grid',
        gap: 12,
        alignContent: 'start',
        minWidth: 0,
    },
    nationCountryChip: {
        display: 'inline-flex',
        width: 'max-content',
        alignItems: 'center',
        gap: 7,
        padding: '5px 11px',
        borderRadius: 999,
        border: '1px solid #E6E9EE',
        background: '#FFFFFF',
        fontSize: 12,
        fontWeight: 700,
        color: '#1B2430',
        whiteSpace: 'nowrap',
    },
    nationCountryDot: {
        width: 7,
        height: 7,
        borderRadius: '50%',
    },
    nationHeading: {
        fontSize: 'clamp(20px, 2vw, 26px)',
        lineHeight: 1.2,
        letterSpacing: '-0.02em',
        fontWeight: 800,
        margin: 0,
        color: '#1B2430',
    },
    nationBodyPara: {
        fontSize: 14.5,
        lineHeight: 1.6,
        margin: 0,
        color: '#5B6470',
        maxWidth: '62ch',
    },
    nationChipsWrap: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
    },
    nationChipItem: {
        padding: '6px 11px',
        borderRadius: 999,
        background: '#FBEDE4',
        color: '#A63C0C',
        fontSize: 12.5,
        fontWeight: 700,
        whiteSpace: 'nowrap',
    },
    nationPhotosGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        gap: 10,
        marginTop: 4,
    },
    nationPhotoImg: {
        width: '100%',
        aspectRatio: '3/2',
        objectFit: 'cover',
        borderRadius: 12,
        display: 'block',
        background: '#F4F6F9',
    },

    // ── SECTION 7: ROLLOUT ────────────────────────────────────────────────────
    rolloutSection: {
        background: '#FFFFFF',
    },
    rolloutTitle: {
        fontSize: 'clamp(28px, 3.2vw, 44px)',
        lineHeight: 1.1,
        letterSpacing: '-0.025em',
        fontWeight: 800,
        margin: 0,
        maxWidth: '36ch',
        color: '#1B2430',
    },
    rolloutLead: {
        fontSize: 15.5,
        lineHeight: 1.6,
        margin: 0,
        maxWidth: '68ch',
        color: '#5B6470',
    },
    rolloutPhasesGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gap: 'clamp(12px, 1.4vw, 16px)',
        marginTop: 36,
        '@media (max-width: 960px)': {
            gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        },
        '@media (max-width: 560px)': {
            gridTemplateColumns: '1fr',
        },
    },
    rolloutPhaseCol: {
        display: 'grid',
        gridTemplateRows: 'auto 1fr',
        gap: 14,
        minWidth: 0,
    },
    rolloutBadgeRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
    },
    rolloutBadgeNum: {
        flex: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: '50%',
        background: '#FFFFFF',
        fontSize: 14,
        fontWeight: 800,
        color: '#1B2430',
        fontVariantNumeric: 'tabular-nums',
    },
    rolloutDividerLine: {
        flex: 1,
        height: 1,
        background: '#E1E6EC',
    },
    rolloutPhaseCard: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        height: '100%',
        padding: 'clamp(18px, 2vw, 24px)',
        border: '1px solid #E6E9EE',
        borderRadius: 20,
        background: '#FFFFFF',
    },
    rolloutPhaseChip: {
        fontSize: 11.5,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
    },
    rolloutPhaseHeading: {
        fontSize: 'clamp(20px, 1.9vw, 24px)',
        lineHeight: 1.2,
        letterSpacing: '-0.02em',
        fontWeight: 800,
        margin: 0,
        color: '#1B2430',
    },
    rolloutPhaseBody: {
        fontSize: 14,
        lineHeight: 1.6,
        margin: 0,
        color: '#5B6470',
    },
    rolloutLightboxWrap: {
        marginTop: 'auto',
        width: '100%',
        display: 'block',
    },
    rolloutPhaseImg: {
        width: '100%',
        aspectRatio: '16/10',
        objectFit: 'cover',
        borderRadius: 12,
        display: 'block',
        background: '#F4F6F9',
    },
    rolloutTimelineStrip: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px 10px',
        alignItems: 'center',
        marginTop: 20,
        padding: '16px 20px',
        borderRadius: 16,
        border: '1px solid #E6E9EE',
        fontSize: 13.5,
        fontWeight: 600,
    },
    rolloutTimelineItem: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        color: '#1B2430',
    },
    rolloutTimelineDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        background: '#ED6628',
    },

    // ── SECTION 8: BOTTOM CTA ─────────────────────────────────────────────────
    ctaSection: {
        marginTop: 'clamp(24px, 3vw, 40px)',
        background: '#172939',
        color: '#FFFFFF',
    },
    ctaInner: {
        maxWidth: 1320,
        margin: '0 auto',
        padding: 'clamp(36px, 4.5vw, 56px) clamp(20px, 4vw, 56px)',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '24px 48px',
        alignItems: 'center',
        justifyContent: 'space-between',
        [MOBILE]: {
            padding: '40px 20px',
        },
    },
    ctaHeading: {
        fontSize: 'clamp(28px, 3.2vw, 44px)',
        lineHeight: 1.08,
        letterSpacing: '-0.03em',
        fontWeight: 800,
        margin: 0,
        flex: '1 1 auto',
        color: '#FFFFFF',
    },
    btnRequestCta: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        height: 54,
        padding: '0 26px',
        borderRadius: 999,
        background: '#ED6628',
        color: '#FFFFFF',
        border: 'none',
        textDecoration: 'none',
        fontSize: 16,
        fontWeight: 700,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        transition: 'background 200ms cubic-bezier(.32,.72,0,1)',
        '&:hover': {
            background: '#D5581D',
            color: '#FFFFFF',
        },
    },
}));

const PbdqDqEveryChildPageContent = () => {
    const classes = useStyles();
    const openAgentChat = useAgentChat();
    const [extIndex, setExtIndex] = useState(0);
    const [quoteIndex, setQuoteIndex] = useState(0);

    const ext = EXTENSIONS[extIndex];
    const quote = QUOTES[quoteIndex];

    const goQuote = (i) => setQuoteIndex((i + QUOTES.length) % QUOTES.length);

    useEffect(() => {
        const timer = setInterval(() => {
            setQuoteIndex((prev) => (prev + 1) % QUOTES.length);
        }, 8000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className={classes.pageWrapper}>
            <PbdqNav />

            {/* SECTION 0: HERO (Introduction) */}
            <section aria-label="Introduction" className={clsx(classes.sectionOuter, classes.heroSection)}>
                <div className={classes.heroInner}>
                    <div className={classes.heroTopRow}>
                        <div className={classes.heroTextCol}>
                            <h1 className={classes.heroTitle}>
                                <span className={classes.accent}>#DQEveryChild</span> —<br />
                                the proven program<br />
                                behind a global movement.
                            </h1>

                            <p className={classes.heroLead}>
                                #DQEveryChild equips children aged 8–12 with the knowledge, skills and values they need to participate safely, responsibly and confidently in the digital world.
                            </p>
                            {/* <p className={classes.heroBodyPara}>
                                Developed by DQ Institute and delivered with more than 100 partners, the program has reached over 1.5 million children across 80+ countries in 21 languages. Its globally recognized framework later became the foundation of the IEEE 3527.1™ Standard for Digital Intelligence.
                            </p>
                            <p className={classes.heroBodyPara}>
                                Today, #DQEveryChild is available as a ready-to-deploy national or regional program — with implementation planning, localization, partner coordination and rollout support provided by our team.
                            </p>
                            <p className={classes.heroCalloutBadge}>
                                Delivered as a managed program and quoted separately. It is not activated through the Powered by DQ workspace.
                            </p> */}
                        </div>

                        <div className={classes.heroArtCol} data-hero-art="">
                            <div className={classes.heroPhotoCard} data-hero-photo="">
                                <PbdqImageLightboxWrapper
                                    src={DqEveryChildClassroomsHero}
                                    alt="#DQEveryChild in classrooms and school assemblies: children at DQ World computers, raising hands in class, and a full-hall assembly"
                                    caption="#DQEveryChild in classrooms and school assemblies"
                                    className={classes.heroLightboxWrap}
                                >
                                    <img
                                        src={DqEveryChildClassroomsHero}
                                        alt="#DQEveryChild in classrooms and school assemblies: children at DQ World computers, raising hands in class, and a full-hall assembly"
                                        className={classes.heroImg}
                                    />
                                </PbdqImageLightboxWrapper>
                                <div aria-hidden="true" className={classes.heroGradientOverlay} />
                                <div aria-hidden="true" className={classes.heroRing1} />
                                <div aria-hidden="true" className={classes.heroRing2} />
                            </div>
                        </div>
                    </div>

                    <div className={classes.proofGrid}>
                        {STATS.map((p) => (
                            <div key={p.label} className={classes.proofItem}>
                                <p className={classes.proofNum}>{p.value}</p>
                                <p className={classes.proofLabel}>{p.label}</p>
                            </div>
                        ))}
                    </div>

                    <div className={classes.heroBtnRow}>
                        <button type="button" onClick={openAgentChat} className={classes.btnRequestHero}>
                            Request this program
                        </button>
                        <a href="#rollout" className={classes.btnPlanRollout}>
                            Plan a national or regional rollout
                        </a>
                    </div>
                </div>
            </section>

            {/* SECTION 2: MANDATORY CORE (DQ World) */}
            <section aria-label="Mandatory core" className={clsx(classes.sectionOuter, classes.coreSection)}>
                <div className={classes.sectionInner}>
                    <div className={classes.coreBanner}>
                        <div className={classes.coreLeftCol}>
                            <span className={classes.coreTagBadge}>Mandatory core</span>
                            <h2 className={classes.coreHeading}>DQ World</h2>
                            <p className={classes.corePara}>
                                The learning foundation of every #DQEveryChild rollout. DQ World is a research-based online program that builds and measures eight core digital citizenship competencies, helping children become safer, more responsible and more capable online.
                            </p>
                            <p className={classes.corePara}>
                                Launched in 2016 with Singtel, Nanyang Technological University (NTU) and Singapore’s Inter-Ministry Cyber Wellness Steering Committee, the program has demonstrated measurable impact through peer-reviewed research: an average 10% improvement in DQ scores and a 15% reduction in cyber-risk exposure.
                            </p>
                            <div className={classes.coreLogosBlock}>
                                <span className={classes.coreLogosLabel}>Launched in 2016 with</span>
                                <div className={classes.coreLogosRow}>
                                    <div className={classes.coreLogoBox}>
                                        <img
                                            src={LogoSingtel}
                                            alt="Singtel"
                                            className={classes.coreLogoImg}
                                            style={{ maxHeight: 38, maxWidth: 120 }}
                                        />
                                    </div>
                                    <div className={classes.coreLogoBox}>
                                        <img
                                            src={LogoNTU}
                                            alt="NTU Singapore"
                                            className={classes.coreLogoImg}
                                            style={{ maxHeight: 38, maxWidth: 124 }}
                                        />
                                    </div>
                                    <div className={classes.coreLogoBox}>
                                        <img
                                            src={LogoNIE}
                                            alt="NIE Singapore"
                                            className={classes.coreLogoImg}
                                            style={{ maxHeight: 48, maxWidth: 120 }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={classes.coreRightCol}>
                            <div className={classes.coreVideoFrame}>
                                <iframe
                                    src="https://www.youtube-nocookie.com/embed/Y_XonvNOkOk?rel=0&modestbranding=1&autoplay=1&mute=1&loop=1&playlist=Y_XonvNOkOk"
                                    title="DQ World"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                    className={classes.coreIframe}
                                />
                            </div>
                            <ul className={classes.coreFeaturesList}>
                                {DQ_WORLD_CORE_FEATURES.map((c) => (
                                    <li key={c} className={classes.coreFeatureItem}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ED6628" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ marginTop: 2 }}>
                                            <path d="m5 12 5 5L20 7" />
                                        </svg>
                                        <span>{c}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 3: EXTEND YOUR INITIATIVE */}
            <section aria-label="Extend your initiative" className={clsx(classes.sectionOuter, classes.extendSection)}>
                <div className={classes.sectionInner}>
                    <div>
                        <span className={classes.sectionOverline}>Extend your initiative</span>
                        <div className={classes.extendHeaderRow}>
                            <h2 className={classes.extendTitle}>
                                Start with DQ World. <span className={classes.accent}>Build a movement around it.</span>
                            </h2>
                            <p className={classes.extendDesc}>
                                DQ World forms the learning core of every #DQEveryChild rollout. Add the components that match your goals, audience and budget — expanding the initiative’s reach, depth and public engagement.
                            </p>
                        </div>
                    </div>

                    <div className={classes.extTabsGrid} role="tablist" aria-label="Extensions">
                        {EXTENSIONS.map((t, i) => {
                            const isSelected = i === extIndex;
                            return (
                                <button
                                    key={t.chip}
                                    type="button"
                                    role="tab"
                                    aria-selected={isSelected}
                                    onClick={() => setExtIndex(i)}
                                    className={clsx(classes.extTabBtn, isSelected && classes.extTabBtnSelected)}
                                    style={{
                                        border: `1px solid ${isSelected ? EXT_BARS[i] : '#E6E9EE'}`,
                                        borderTop: `4px solid ${EXT_BARS[i]}`,
                                        background: isSelected ? EXT_TINTS[i] : '#FFFFFF',
                                    }}
                                >
                                    <span className={classes.extTabChip} style={{ color: EXT_INKS[i] }}>{t.chip}</span>
                                    <span className={classes.extTabH}>{t.h}</span>
                                </button>
                            );
                        })}
                    </div>

                    <div
                        role="tabpanel"
                        className={classes.extPanel}
                        style={{ borderTop: `4px solid ${EXT_BARS[extIndex]}` }}
                    >
                        <div className={classes.extPanelLeft}>
                            <span
                                className={classes.extBadge}
                                style={{ background: EXT_TINTS[extIndex], color: EXT_INKS[extIndex] }}
                            >
                                {`Extension ${extIndex + 1} of 5`}
                            </span>
                            <h3 className={classes.extHeading}>{ext.h}</h3>
                            <p className={classes.extSellText}>{ext.sell}</p>
                            <ul className={classes.extPointsList}>
                                {ext.points.map((pt) => (
                                    <li key={pt} className={classes.extPointItem}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ED6628" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ marginTop: 2 }} aria-hidden="true">
                                            <path d="m5 12 5 5L20 7" />
                                        </svg>
                                        <span>{pt}</span>
                                    </li>
                                ))}
                            </ul>
                            <div className={classes.extChipsWrap}>
                                {ext.items.map((it) => (
                                    <span key={it} className={classes.extChipItem}>{it}</span>
                                ))}
                            </div>

                            {ext.photos && ext.photos.length > 0 && (
                                <div className={classes.extPhotosWrap}>
                                    {ext.photos.map((p) => (
                                        <PbdqImageLightboxWrapper
                                            key={p.alt}
                                            src={p.img}
                                            alt={p.alt}
                                            caption={p.alt}
                                        >
                                            <img src={p.img} alt={p.alt} className={classes.extPhotoThumb} />
                                        </PbdqImageLightboxWrapper>
                                    ))}
                                </div>
                            )}

                            {extIndex === 0 && (
                                <div>
                                    <a
                                        href="https://www.dropbox.com/scl/fi/y1vqu6ktfd8o0zjp5pxmt/iZ_press-release.pdf?rlkey=orxyjomozmkr6lpjor82s6n2i&st=dsjjm39z&raw=1"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={classes.extPressReleaseLink}
                                    >
                                        Read the press release →
                                    </a>
                                </div>
                            )}
                        </div>

                        <aside className={classes.extPanelRight}>
                            {ext.videos && ext.videos.some((v) => !!v.type) && (
                                <span className={classes.extWatchLabel}>Watch</span>
                            )}
                            <div className={classes.extVideosList}>
                                {ext.videos && ext.videos.map((v) => (
                                    <figure key={v.title} className={classes.extVideoFigure}>
                                        <div className={classes.extVideoWrap}>
                                            {v.type === 'vimeo' && (
                                                <iframe
                                                    src={`https://player.vimeo.com/video/${v.id}?badge=0&autopause=0&autoplay=1&muted=1&loop=1&player_id=0&app_id=58479`}
                                                    title={v.title}
                                                    allow="autoplay; fullscreen; picture-in-picture"
                                                    allowFullScreen
                                                    className={classes.coreIframe}
                                                />
                                            )}
                                            {v.type === 'youtube' && (
                                                <iframe
                                                    src={`https://www.youtube-nocookie.com/embed/${v.id}?rel=0&modestbranding=1&autoplay=1&mute=1&loop=1&playlist=${v.id}`}
                                                    title={v.title}
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                    allowFullScreen
                                                    className={classes.coreIframe}
                                                />
                                            )}
                                            {v.type === 'file' && (
                                                <video
                                                    autoPlay
                                                    muted
                                                    loop
                                                    playsInline
                                                    controls
                                                    preload="auto"
                                                    src={v.src}
                                                    style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain' }}
                                                />
                                            )}
                                            {v.type === 'link' && (
                                                <a href={v.href} target="_blank" rel="noopener noreferrer" className={classes.extVideoLinkOverlay}>
                                                    {v.placeholderImg && (
                                                        <img src={v.placeholderImg} alt={v.title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                                                    )}
                                                    <span aria-hidden="true" className={classes.playBtnCircle}>
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                                            <path d="M8 5v14l11-7z" />
                                                        </svg>
                                                    </span>
                                                </a>
                                            )}
                                            {!v.type && (
                                                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    {v.placeholderImg && (
                                                        <img src={v.placeholderImg} alt={v.title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                                                    )}
                                                    <span aria-hidden="true" className={classes.playBtnCircle}>
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                                            <path d="M8 5v14l11-7z" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        <figcaption className={classes.extVideoFigcaption}>
                                            <span className={classes.extVideoFigTitle}>{v.title}</span>
                                            <span className={classes.extVideoFigSub}>{v.sub}</span>
                                        </figcaption>
                                    </figure>
                                ))}
                            </div>
                        </aside>
                    </div>
                </div>
            </section>

            {/* SECTION 4: RESEARCH AND RECOGNITION */}
            <section aria-label="Research and recognition" className={clsx(classes.sectionOuter, classes.researchSection)}>
                <div className={classes.sectionInner}>
                    <span className={classes.sectionOverline}>Research and recognition</span>
                    <h2 className={classes.researchTitle}>Peer-reviewed, globally reported.</h2>
                    <div className={classes.researchGrid}>
                        {PUBS.map((p) => (
                            <a
                                key={p.title}
                                href={p.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={classes.researchCard}
                            >
                                <span className={classes.researchLogoBox}>
                                    <img
                                        src={p.logo}
                                        alt={p.outlet}
                                        className={classes.researchLogoImg}
                                        style={p.logoStyle || {}}
                                    />
                                </span>
                                <span className={classes.researchOutlet}>{p.outlet}</span>
                                <span className={classes.researchHeading}>
                                    {p.title} <span style={{ color: '#ED6628' }}>↗</span>
                                </span>
                            </a>
                        ))}
                    </div>
                </div>
            </section>

            {/* SECTION 5: WHAT LEADERS AND PRESS HAVE SAID */}
            <section aria-label="What leaders and press have said" className={clsx(classes.sectionOuter, classes.quotesSection)}>
                <div className={classes.sectionInner}>
                    <span className={classes.sectionOverline}>What leaders and press have said</span>
                    <div className={classes.quoteContainerCard}>
                        <div className={classes.quoteInnerBox}>
                            <div className={classes.quoteBodyRow}>
                                <blockquote className={classes.blockquote}>
                                    <p className={classes.quoteText}>“{quote.text}”</p>
                                </blockquote>
                                <div className={classes.quoteLeaderSide}>
                                    <div className={classes.quoteLeaderCircle}>
                                        <img
                                            src={quote.photo}
                                            alt={quote.attribution}
                                            className={classes.quoteLeaderImg}
                                            style={quote.photoStyle}
                                        />
                                    </div>
                                    <span className={classes.quoteLeaderAttribution}>{quote.attribution}</span>
                                </div>
                            </div>
                            <div className={classes.quoteControlsRow}>
                                <div className={classes.quoteDotsGroup}>
                                    {QUOTES.map((q, i) => (
                                        <button
                                            key={q.attribution}
                                            type="button"
                                            onClick={() => goQuote(i)}
                                            aria-label={`Quote ${i + 1}`}
                                            className={classes.quoteDotBtn}
                                            style={{
                                                width: i === quoteIndex ? 22 : 8,
                                                background: i === quoteIndex ? '#ED6628' : '#D5D9E0',
                                            }}
                                        />
                                    ))}
                                </div>
                                <div className={classes.quoteArrowsGroup}>
                                    <button
                                        type="button"
                                        onClick={() => goQuote(quoteIndex - 1)}
                                        aria-label="Previous quote"
                                        className={classes.quoteArrowBtn}
                                    >
                                        ←
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => goQuote(quoteIndex + 1)}
                                        aria-label="Next quote"
                                        className={classes.quoteArrowBtn}
                                    >
                                        →
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SECTION 6: DELIVERED WITH NATIONAL PARTNERS */}
            <section aria-label="Delivered with national partners" className={clsx(classes.sectionOuter, classes.nationsSection)}>
                <div className={classes.sectionInner}>
                    <span className={classes.sectionOverline}>Proven in nations around the world</span>
                    <div className={classes.extendHeaderRow}>
                        <h2 className={classes.nationsTitle}>
                            Delivered with national partners <span className={classes.accent}>around the world</span>
                        </h2>
                        <p className={classes.nationsLead}>
                            How telecoms and technology leaders brought #DQEveryChild to their countries.
                        </p>
                    </div>

                    <div className={classes.nationsList}>
                        {NATIONS.map((n) => (
                            <article key={n.country} className={classes.nationArticle}>
                                <div className={classes.nationVideoCol}>
                                    <span className={classes.extWatchLabel}>Watch</span>
                                    <div className={classes.nationVideoWrap}>
                                        {n.video && n.video.type === 'youtube' && (
                                            <iframe
                                                src={`https://www.youtube-nocookie.com/embed/${n.video.id}?rel=0&modestbranding=1&autoplay=1&mute=1&loop=1&playlist=${n.video.id}`}
                                                title={n.h}
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                allowFullScreen
                                                className={classes.coreIframe}
                                            />
                                        )}
                                        {n.video && n.video.type === 'vimeo' && (
                                            <iframe
                                                src={`https://player.vimeo.com/video/${n.video.id}?badge=0&autopause=0&autoplay=1&muted=1&loop=1&player_id=0&app_id=58479`}
                                                title={n.h}
                                                allow="autoplay; fullscreen; picture-in-picture"
                                                allowFullScreen
                                                className={classes.coreIframe}
                                            />
                                        )}
                                        {n.video && n.video.type === 'file' && (
                                            <video
                                                autoPlay
                                                muted
                                                loop
                                                playsInline
                                                controls
                                                preload="auto"
                                                src={n.video.src}
                                                style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'contain' }}
                                            />
                                        )}
                                    </div>
                                </div>

                                <div className={classes.nationRightCol}>
                                    <span className={classes.nationCountryChip}>
                                        <span className={classes.nationCountryDot} style={{ background: n.dot }} />
                                        {n.country}
                                    </span>
                                    <h3 className={classes.nationHeading}>{n.h}</h3>
                                    <p className={classes.nationBodyPara}>{n.b}</p>
                                    <div className={classes.nationChipsWrap}>
                                        {n.chips.map((c) => (
                                            <span key={c} className={classes.nationChipItem}>{c}</span>
                                        ))}
                                    </div>
                                    <div className={classes.nationPhotosGrid}>
                                        {n.photos.map((p) => (
                                            <PbdqImageLightboxWrapper
                                                key={p.alt}
                                                src={p.img}
                                                alt={p.alt}
                                                caption={p.alt}
                                            >
                                                <img src={p.img} alt={p.alt} className={classes.nationPhotoImg} />
                                            </PbdqImageLightboxWrapper>
                                        ))}
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            {/* SECTION 7: THE ROLLOUT */}
            <section id="rollout" aria-label="The rollout" className={clsx(classes.sectionOuter, classes.rolloutSection)}>
                <div className={classes.sectionInner}>
                    <span className={classes.sectionOverline}>The rollout</span>
                    <div className={classes.extendHeaderRow}>
                        <h2 className={classes.rolloutTitle}>
                            Your national rollout, <span className={classes.accent}>at a glance</span>
                        </h2>
                        <p className={classes.rolloutLead}>
                            Four steps, three to six months, from agreement to a national impact report.
                        </p>
                    </div>

                    <div className={classes.rolloutPhasesGrid}>
                        {ROLLOUT_STEPS.map((s, i) => (
                            <div key={s.h} className={classes.rolloutPhaseCol}>
                                <div className={classes.rolloutBadgeRow}>
                                    <span
                                        className={classes.rolloutBadgeNum}
                                        style={{ border: `2px solid ${s.ring}` }}
                                    >
                                        {i + 1}
                                    </span>
                                    <span className={classes.rolloutDividerLine} />
                                </div>
                                <div className={classes.rolloutPhaseCard}>
                                    <span className={classes.rolloutPhaseChip} style={{ color: s.ink }}>
                                        {s.chip}
                                    </span>
                                    <h3 className={classes.rolloutPhaseHeading}>{s.h}</h3>
                                    <p className={classes.rolloutPhaseBody}>{s.b}</p>
                                    <PbdqImageLightboxWrapper
                                        src={s.img}
                                        alt={s.alt}
                                        caption={`${s.chip} · ${s.h}`}
                                        className={classes.rolloutLightboxWrap}
                                    >
                                        <img src={s.img} alt={s.alt} className={classes.rolloutPhaseImg} />
                                    </PbdqImageLightboxWrapper>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className={classes.rolloutTimelineStrip}>
                        {TIMELINE.map((t) => (
                            <span key={t} className={classes.rolloutTimelineItem}>
                                <span className={classes.rolloutTimelineDot} />
                                {t}
                            </span>
                        ))}
                    </div>
                </div>
            </section>

            {/* SECTION 8: NEXT STEP (BOTTOM CTA) */}
            <section aria-label="Next step" className={clsx(classes.sectionOuter, classes.ctaSection)}>
                <div className={classes.ctaInner}>
                    <h3 className={classes.ctaHeading}>Empower Every Child with Digital Citizenship</h3>
                    <button type="button" onClick={openAgentChat} className={classes.btnRequestCta}>
                        Request this program
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12h14" />
                            <path d="m12 5 7 7-7 7" />
                        </svg>
                    </button>
                </div>
            </section>

            <PbdqFooter />
        </div>
    );
};

export default PbdqDqEveryChildPageContent;
